import logo from '../logo.png';
// import PrivacyModal from './PrivacyModal';
import { Link } from "react-router-dom";

const cols = [
  {
    title: "Programs",
    links: [
      ["Programs", "/programs"],
      ["Online MBA", "/programs"],
      ["Online MCA", "/programs"],
      ["Online MA", "/programs"],
      ["Online MCom", "/programs"],
      ["Diploma Courses", "/programs"],
    ],
  },
  {
    title: "Universities",
    links: [
      ["Amity University", "/programs"],
      ["DY Patil University", "/programs"],
      ["NMIMS", "/programs"],
      ["Manipal University", "/programs"],
      ["Chandigarh University", "/programs"],
      ["View All", "/programs"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About iGrade", "/about"],
      ["Student Stories", "/success-stories"],
      ["How It Works", "/process"],
      ["Blogs", "/blogs"],
      ["FAQ", "/faq"],
      ["Contact Us", "/contact"],
    ],
  },
];

export function Footer() {
  return (
    <footer style={{ background: '#070F26', color: 'rgba(255,255,255,0.65)', padding: '64px 6% 32px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 56 }}>
        <div>
          <a href="#home" style={{ display: 'inline-flex', marginBottom: 18 }}>
            <img src={logo} alt="iGrade Education" style={{ height: 48, width: 'auto', display: 'block' }} />
          </a>
          <p style={{ fontSize: 14, lineHeight: 1.75, maxWidth: 280 }}>
            India's most trusted online education registration platform — connecting ambitious learners to top-ranked, UGC-approved universities since 2020.
          </p>
          <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
            {[].map((ic, i) => (
              <div key={i} style={{ width: 36, height: 36, background: 'rgba(255,255,255,0.08)', borderRadius: 8, display: 'grid', placeItems: 'center', fontSize: 16, cursor: 'pointer', transition: 'all 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--yellow)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
              >{ic}</div>
            ))}
          </div>
        </div>
        {cols.map(c => (
          <div key={c.title}>
            <h5 style={{ fontFamily: 'DM Sans,sans-serif', fontWeight: 800, fontSize: 11, letterSpacing: '2px', textTransform: 'uppercase', color: '#fff', marginBottom: 20 }}>{c.title}</h5>
            {c.links.map(([label, path]) => (
              <Link
                key={label}
                to={path}
                style={{
                  display: "block",
                  fontSize: 14,
                  color: "rgba(255,255,255,0.55)",
                  marginBottom: 10,
                  transition: "color 0.2s",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "var(--yellow)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = "rgba(255,255,255,0.55)")
                }
              >
                {label}
              </Link>
            ))}
          </div>
        ))}
      </div>



      <style>{`
        @media(max-width:860px) { footer > div:first-child { grid-template-columns: 1fr 1fr !important; } }
        @media(max-width:560px) { footer > div:first-child { grid-template-columns: 1fr !important; } }
      `}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <Link
          to="/privacy-policy"
          style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.55)",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            transition: "color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.color = "var(--yellow)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.color = "rgba(255,255,255,0.55)")
          }
        >
          Privacy Policy
        </Link>

        <p
          style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.4)",
          }}
        >
          Made with ❤️ for India's learners
        </p>
      </div>
    </footer>
  );
}

export function WhatsAppFloat() {
  return (
    <>
      <a href="https://wa.me/919136283227" target="_blank" rel="noreferrer"
        style={{
          position: 'fixed', bottom: 32, right: 32, zIndex: 888,
          width: 58, height: 58, background: '#25D366', borderRadius: '50%',
          display: 'grid', placeItems: 'center',
          boxShadow: '0 6px 24px rgba(37,211,102,0.4)',
          textDecoration: 'none', transition: 'all 0.25s',
          animation: 'waPulse 3s ease infinite',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.12)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </a>
      <style>{`
        @keyframes waPulse {
          0%,100%{box-shadow:0 6px 24px rgba(37,211,102,.4)}
          50%{box-shadow:0 6px 32px rgba(37,211,102,.6),0 0 0 10px rgba(37,211,102,.08)}
        }
      `}</style>
    </>
  );
}